<div class="container-fluid p-5 pt-3" style="min-height: calc(100vh - 57px) !important">
    <div class="row">
        <div class="col-12 ps-5">
            <div aria-label="breadcrumb" class="text-right float-right">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-grey" href="/home">HOME</a></li>
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-grey" href="/process-list">Centralización Remuneraciones</a></li>
                    <li class="breadcrumb-item"><a class="fzas-breadcrumb-blue">Crear Nuevo Proceso</a></li>
                </ol>
            </div>
        </div>
        <div class="col-12 ps-5">
            <p class="fzas-titulo-componente">Creación Proceso Normal</p>
        </div>
        <div class="col-12">
            <div class="container card-container">
                <div class="row">
                    <div class="col px-4">
                        <div class="card border-0">
                            <div class="card-body px-4">
                                <form [formGroup]="procesoDatosForm" class="row">
                                    <div class="col-12">
                                        <p class="fzas-title-formulario m-0">Identificación Proceso</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-9">
                                        <label for="procesoNombre" class="form-label fzas-text-input">Nombre Proceso</label>
                                        <input type="text" formControlName="procesoNombre" name="procesoNombre" placeholder="Escribe el nombre del proceso" class="form-control" (input)="validarAlfanumerico($event)"/>
                                    </div>
                                    <div class="col-12 col-md-6 col-xl-3">
                                        <label for="procesoPeriodo" class="form-label fzas-text-input">Periodo</label>
                                        <div class="row">
                                            <div class="col-12">
                                                <p-calendar
                                                  class="calendar-periodo"
                                                  formControlName="procesoPeriodo"
                                                  name="procesoPeriodo"
                                                  placeholder="Mes/Año"
                                                  (onSelect)="onChangePeriodo($event)"
                                                  view="month"
                                                  dateFormat="M/yy"
                                                  [readonlyInput]="true"
                                                  [yearNavigator]="true"
                                                  [monthNavigator]="true"
                                                  [yearRange]="'2000:2030'">
                                                </p-calendar>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 px-5 pt-4 d-flex justify-content-end gap-3">
                        <button type="button" class="btn btn-cancelar-accion" (click)="cancelar()">Cancelar</button>
                        <button type="button" class="btn btn-aplicar-accion" (click)="crearProceso()">Crear Proceso</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>